export const customerFileTabs = [
  {
    id: 'details',
    title: 'Customer Details',
  },
  // {
  //   id: 'summary',
  //   title: 'Summary',
  // },
  // {
  //   id: 'subsidiaries',
  //   title: 'Subsidiaries',
  // },
  {
    id: 'jobs',
    title: 'Jobs',
  },
  {
    id: 'notes',
    title: 'Notes',
  },
  // {
  //   id: 'quotes',
  //   title: 'Quotes',
  // },
  // {
  //   id: 'site-docs',
  //   title: 'Site Docs',
  // },
  // {
  //   id: 'csi',
  //   title: 'CSI',
  // },
  {
    id: 'tickets',
    title: 'Tickets',
  },
  // {
  //   id: 'services',
  //   title: 'Services',
  // },
  // {
  //   id: 'pre-paid',
  //   title: 'Pre-paid',
  // },
  {
    id: 'emails',
    title: 'Emails',
  },
  {
    id: 'discounts',
    title: 'Discounts & Products',
  },
  {
    id: 'sms',
    title: 'SMS',
  },
  // {
  //   id: 'ledger',
  //   title: 'Ledger',
  // },
  // {
  //   id: 'docs',
  //   title: 'Docs',
  // },
];
